import React, { createContext, ReactNode, useState } from 'react';
import { useSessionStorage } from '../../hooks/providers/useSessionStorage';
import IUser from '../../interfaces/IUser';

type PropsUserContext = {
  state: IUser;
  setState: React.Dispatch<React.SetStateAction<IUser>>;
};

const DEFAULT_VALUE = {
  state: {
    expires_in: 0,
    username: '',
    access_token: '',
    refresh_token: '',
    name: '',
    email: '',
    tenantDomain: '',
    logged: false,
    typeAuth: '',
    fullUser: false,
    rhUser: false,
    managerUser: false,
    resources: [''],
    resourcesWithActions: {},
  },
  setState: () => {},
};

const UserContext = createContext<PropsUserContext>(DEFAULT_VALUE);

const UserContextProvider = ({ children }: { children: ReactNode }) => {
  const localStorage = useSessionStorage();

  const user = localStorage.getItem('user');
  const {
    expires_in,
    username,
    access_token,
    refresh_token,
    name,
    email,
    tenantDomain,
    logged,
    typeAuth,
    fullUser,
    rhUser,
    managerUser,
    resources,
    resourcesWithActions,
  } = user || {
    expires_in: 0,
    username: '',
    access_token: '',
    refresh_token: '',
    name: '',
    email: '',
    tenantDomain: '',
    logged: false,
    typeAuth: '',
    resources: [''],
    resourcesWithActions: {},
  };

  const [state, setState] = useState({
    expires_in,
    username,
    access_token,
    refresh_token,
    name,
    email,
    tenantDomain,
    logged,
    typeAuth,
    fullUser,
    rhUser,
    managerUser,
    resources,
    resourcesWithActions,
  });

  return (
    <UserContext.Provider
      value={{
        state,
        setState,
      }}
    >
      {children}
    </UserContext.Provider>
  );
};

export { UserContextProvider };
export default UserContext;
